module.exports = __webpack_public_path__ + "static/media/Churned_Btid.f67c3be7.csv";